import { americanOddsToImpliedProbability as canonicalAmericanOddsToImpliedProbability } from "@/lib/odds";

export const UNDERDOG_BASE_DECIMAL = 1.8621;
export const PICK6_BASE_DECIMAL = 1.82;

function getPostedMultiplier(
  americanOdds: number | null | undefined,
  baseDecimal: number,
): number | null {
  if (americanOdds == null || !Number.isFinite(americanOdds) || americanOdds === 0) return null;
  const decimal = americanOdds > 0
    ? americanOdds / 100 + 1
    : 100 / Math.abs(americanOdds) + 1;
  return Math.round((decimal / baseDecimal) * 100) / 100;
}

export function getUnderdogMultiplier(americanOdds: number | null | undefined, baseDecimal: number = UNDERDOG_BASE_DECIMAL): number | null {
  return getPostedMultiplier(americanOdds, baseDecimal);
}

export function getPick6Multiplier(americanOdds: number | null | undefined): number | null {
  return getPostedMultiplier(americanOdds, PICK6_BASE_DECIMAL);
}

export function americanOddsToImpliedProbability(
  americanOdds: number | null | undefined,
): number | null {
  return canonicalAmericanOddsToImpliedProbability(americanOdds);
}

export function oddsAreBetterForBettor(
  candidate: number | null | undefined,
  baseline: number | null | undefined,
  epsilon = 0.001,
): boolean {
  const candidateImplied = americanOddsToImpliedProbability(candidate);
  const baselineImplied = americanOddsToImpliedProbability(baseline);
  if (candidateImplied == null || baselineImplied == null) {
    return false;
  }
  return candidateImplied + epsilon < baselineImplied;
}
